module.exports = __webpack_public_path__ + "static/img/mini_code.66646aef.jpg";